import { Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

// ctx
import { useEffect, useContext } from 'react'

// hooks
import useKeyPress from 'src/hooks/useKeyPress'

// context
import { NavigationDataContext, NavigationDispatchContext } from 'src/store/navigation/Store'
import { setSwitch, setSwitches } from 'src/store/navigation/actions'

const blockSize = 7
const scaleFactor = 4
const borderSize = 2

const navBarStyle = {
  zIndex: 4,
  position: 'absolute',
  width: '100%',
  padding: '16px',
  backgroundColor: 'black',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end'
}

const buttonsWrapper = {
  display: 'flex',
  gap: '8px',
  flexDirection: 'row'
}

const buttonStyle = {
  height: `${blockSize * scaleFactor + (borderSize * 2)}px`,
  width: `${blockSize * scaleFactor + (borderSize * 2)}px`,
  border: `${borderSize}px solid transparent`
}

const buttonHighlighted = {
  border: `${borderSize}px solid white`
}

const closeIconWrapper = {
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: `${blockSize * scaleFactor + (borderSize * 2)}px`,
  width: `${blockSize * scaleFactor + (borderSize * 2)}px`,
  border: `${borderSize}px solid transparent`
}

const iconStyle = {
  transform: `scale(${scaleFactor})`,
  transformOrigin: 'top left',
  height: blockSize,
  width: blockSize,
  backgroundColor: 'rgba(0,0,0,0.5)'
}

const BottomBar = () => {
  const { navigation } = useContext(NavigationDataContext)
  const { dispatchNavigation } = useContext(NavigationDispatchContext)

  // keyboard support
  const iButtonPressed = useKeyPress('i')
  const cButtonPressed = useKeyPress('c')
  const escapeButtonPressed = useKeyPress('Escape')

  useEffect(() => {
    if (iButtonPressed) {
      handleInventoryButton()
    }
  }, [iButtonPressed])

  useEffect(() => {
    if (cButtonPressed) {
      handleStatsButton()
    }
  }, [cButtonPressed])

  useEffect(() => {
    if (escapeButtonPressed) {
      handleEscapeButton()
    }
  }, [escapeButtonPressed])

  //

  const handleEscapeButton = () => {
    if (navigation.menu_open) {
      setSwitches(dispatchNavigation, [
        { menu_open: false },
        { stats_open: false },
        { inventory_open: false },
        { info_open: false }
      ])
    } else {
      setSwitches(dispatchNavigation, [
        { menu_open: true },
        { info_open: true }
      ])
    }
  }

  const handleStatsButton = () => {
    if (!navigation.menu_open) {
      setSwitch(dispatchNavigation, 'menu_open', true)
    }
    setSwitches(dispatchNavigation, [
      { inventory_open: false },
      { info_open: false },
      { stats_open: true }
    ])
  }

  const handleInventoryButton = () => {
    if (!navigation.menu_open) {
      setSwitch(dispatchNavigation, 'menu_open', true)
    }
    setSwitches(dispatchNavigation, [
      { inventory_open: true },
      { info_open: false },
      { stats_open: false }
    ])
  }

  const handleInfoButton = () => {
    if (!navigation.menu_open) {
      setSwitch(dispatchNavigation, 'menu_open', true)
    }
    setSwitches(dispatchNavigation, [
      { inventory_open: false },
      { info_open: true },
      { stats_open: false }
    ])
  }

  return !navigation.event_open ? (
  <Box sx={navBarStyle} className='nav-bar'>
    <Box sx={buttonsWrapper}>
      {
        navigation.menu_open ? (
          <Box sx={{buttonStyle}}>
            <Box onClick={handleEscapeButton} sx={closeIconWrapper}><CloseIcon sx={{ fontSize: 32 }}/></Box>
          </Box>
        ) : null
      }
      <Box sx={navigation.stats_open ? {...buttonStyle, ...buttonHighlighted } : buttonStyle}>
        <Box sx={iconStyle} className='icon icon_head' onClick={handleStatsButton}/>
      </Box>
      <Box sx={navigation.inventory_open ? {...buttonStyle, ...buttonHighlighted } : buttonStyle}>
        <Box sx={iconStyle} className='icon icon_backpack' onClick={handleInventoryButton}/>
      </Box>
      <Box sx={navigation.info_open ? {...buttonStyle, ...buttonHighlighted } : buttonStyle}>
        <Box sx={iconStyle} className='icon icon_info' onClick={handleInfoButton}/>
      </Box>
    </Box>
  </Box>
  ) : null
}

export default BottomBar
